import { requiresCsrfToken } from './util'
import _ from 'underscore'
import Backbone from '@polleverywhere/backbone'

const fetchCsrfToken = () =>
  Backbone.ajax({
    method: 'GET',
    url: '/api/csrf_token',
    cache: false
  })

const isInvalidCsrfTokenError = jqXHR =>
  jqXHR.status === 422 && jqXHR.responseJSON?.error?.type === 'InvalidAuthenticityToken'

// @namespace Ajax.Csrf
export default class Retry {
  constructor (cache, nextAjax) {
    this.ajax = this.ajax.bind(this)
    this.nextAjax = nextAjax
  }

  ajax (options) {
    if (!requiresCsrfToken(options) || options.csrfRetry) {
      // Short circut because this request doesn't require a retry
      return this.nextAjax(options)
    }

    /*
     * NOTE: We need to be careful that callbacks are triggered in the correct order.
     *       See: http://api.jquery.com/jquery.ajax/#callback-functions
     */

    /*
     * overwrite *current request* callbacks so we can call them
     * in the correct order later on
     */
    const originalOptions = _.pick(options, 'error', 'complete', 'success')
    options.error = (options.complete = (options.success = Backbone.$.noop()))
    const deferRequest = Backbone.$.Deferred()
    const req = this.nextAjax(options)

    req.done(function (...args) {
      // Make sure callbacks in order of success, done, complete
      if (typeof originalOptions.success === 'function') {
        originalOptions.success?.(...args)
      }
      if (originalOptions.complete) { deferRequest.done(originalOptions.complete) }
      return deferRequest.resolve(...arguments)
    })

    req.fail(function (...args) {
      /*
       * handle as a normal error unless it's the first time receiving an
       * invalid CSRF token
       */
      if (isInvalidCsrfTokenError(req)) {
        return fetchCsrfToken()
          .done(function (data, textStatus, jqXHR) {
            _.extend(options, originalOptions)
            options.csrfRetry = true
            /*
             * This will set the error, success, and complete callbacks back up
             * and the deferRequest should have any done / fail promise callbacks
             */
            return Backbone.ajax(options)
              .done(deferRequest.resolve)
              .fail(deferRequest.reject)
          }).fail(function (...args) {
            console?.warn?.('Failed to get new CSRF token')
            originalOptions.error?.(...args)
            if (originalOptions.complete) { deferRequest.fail(originalOptions.complete) }
            return deferRequest.reject(...args)
          })
      } else {
        originalOptions.error?.(...args)
        if (originalOptions.complete) { deferRequest.fail(originalOptions.complete) }
        return deferRequest.reject(...args)
      }
    })
    return deferRequest.promise(req)
  }
}
